'use client';

import Button from '@components/Button';
import { Checkbox, Input, RadioGroup } from '@components/Form';
import Link from 'next/link';
import { useId, useState } from 'react';

import RawHtml from '@components/RawHtml';
import Honeypot from '@components/Honeypot';
import { WagtailPage } from '@/types';
import { removeBaseUrl } from '@utils/url';

type Props = { page_id: number; dates: string[]; thank_you_text?: string; data_protection: WagtailPage };

function DegreeProgramForm(props: Props) {
  const { thank_you_text, data_protection, page_id, dates } = props;
  const [status, setStatus] = useState('idle');

  const id = useId();

  return (
    <div className='container'>
      <form
        id={`form-${id}`}
        className='inhouse-form'
        onSubmit={async event => {
          event.preventDefault();

          const formData = new FormData(event.currentTarget);

          const data: {
            [key: string]: FormDataEntryValue | FormDataEntryValue[];
          } = Object.fromEntries(formData);

          try {
            setStatus('loading');
            const res = await fetch(`${process.env.NEXT_PUBLIC_WAGTAIL_API_URL}/v2/forms/`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                page: page_id,
                form_data: data,
              }),
            });

            if (res.ok) {
              setStatus('success');
            } else {
              setStatus('error');
            }
          } catch (error) {
            setStatus('error');
          }
        }}
      >
        <div className='inhouse-form__row'>
          <Input name='first_name' label='Vorname (First Name)' id={`${id}-first-name`} required />
          <Input name='last_name' label='Nachname (Name)' id={`${id}-last-name`} required />
        </div>
        <div className='inhouse-form__row'>
          <Input name='company' label='Unternehmen (Company)' id={`${id}-company`} required />
        </div>
        <div className='inhouse-form__row'>
          <RadioGroup
            items={dates.map(date => ({ label: date, value: date }))}
            label='An welchem Termin möchten Sie teilnehmen? (Which session would you like to participate?)'
            name='date'
            required
            id={`${id}-date`}
          />
        </div>
        <div className='inhouse-form__terms-of-service'>
          <Checkbox
            id={`${id}-tos`}
            name='terms_of_service'
            label={
              <>
                Ich habe die{' '}
                <Link href={removeBaseUrl(data_protection.full_url)} target='_blank' className='inhouse-form__link'>
                  Datenschutzerklärung
                </Link>{' '}
                zur Kenntnis genommen und akzeptiere sie. (I have read and agree to the Privacy Policy.)
              </>
            }
            value='accepted'
            required
          />
        </div>
        {status === 'success' ? (
          <div className='message message--success'>
            <RawHtml html={thank_you_text} />
          </div>
        ) : null}
        {status === 'error' ? (
          <div className='message message--error'>
            <p>Leider ist etwas schief gegangen... Bitte versuchen Sie es später erneut...</p>
          </div>
        ) : null}
        <Button primary type='submit' disabled={status === 'loading' || status === 'success'}>
          Anmeldung absenden (submit)
        </Button>
        <Honeypot />
      </form>
    </div>
  );
}

export default DegreeProgramForm;
